import React, { useContext, useEffect, useState } from "react";
//import TemplateItem from "./dashboard.templateItem.component";
import Swal from "sweetalert";
import Popup from "reactjs-popup";
import Templates from "../dashboard.templatesArea.component/TemplatesArea";
import SaveProject from "../dashboard.SaveProject.component/SaveProject";
import Notification from "../Dashboard.Notification.component/Notification";
import WhatsNew, { WhatsNewButton, useWhatsNew } from "./WhatsNew";
import MyVideos from "./MyVideos";
import Create from "../dashboard.create.component/create.component";
import AIStudio from "../../AIStudio/AIStudio";
import { AIStudioBanner } from "../../AIStudio/AIDashboardBits";
import { AIStudioGate } from "../../AIStudio/AIAccess";
import Tour from "reactour";
import { Tooltip } from "react-tippy";
import PopRightArea from "./PopRightArea";
import PopL_AreaR_Side from "./PopL_AreaR_Side";
import AuthContext from "../../context/userAuth.context";
import Lottie from "react-lottie";
import ForTemp from "../../assets/Loader/dashboardAnimations/chooseTemplate.json";
import ForRec from "../../assets/Loader/dashboardAnimations/Record.json";
import ForEdit from "../../assets/Loader/dashboardAnimations/Editor.json";
import CharacterContext from "../../context/CharacterContext";
import AllRecentTemplates from "./ViewAllRecent";
import RecentUseTemplates from "./RecentUseTemplates";
import PopularTemplates from "./PopularTemplates";
import AllPopularTemplates from "./ViewAllPopular";
import { useHistory } from "react-router";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import PasswordIcon from '@mui/icons-material/Password';
import PersonIcon from "@mui/icons-material/Person";
import load from "../../assets/Loader/AssetLoader.json";
import axios from "axios";
import { VrpanoOutlined } from "@mui/icons-material";
import { async } from "@firebase/util";
import AgencyPanel from "../../Administration/AgencyPanel";
import MyPurchases from "./MyPurchases";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
var get;

export const RightArea = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const { CharPopup, setCharPopup, redirect, setredirect } =
    useContext(CharacterContext);

  //just trying
  const [showCreationPopup, setshowCreationPopup] = useState(false);
  const [activePreviewGesture, setactivePreviewGesture] = useState("Stand");
  const [createdCharacterPath, setcreatedCharacterPath] = useState({});
  const [createdCharacterURL, setcreatedCharacterURL] = useState("");
  const [arrayPreviewGestures, setarrayPreviewGestures] = useState([
    { gesture: "Stand", isActive: "true" },
    { gesture: "Chill", isActive: "false" },
    {
      gesture: "Selfie",
      isActive: "false",
    },
    { gesture: "Glommy", isActive: "false" },
    { gesture: "Show1", isActive: "false" },
  ]);

  // {gesture:"Dance",isActive:"true"},
  // {gesture:"Chill",isActive:"false"},{
  //   gesture:"Selfie",isActive:"false"},
  // {gesture:"Clap",isActive:"false"},
  // {gesture:"Wave",isActive:"false"}

  const [popupload, setpopupload] = useState(false);

  const { DivName, setDivName, Role, UserData, authenticationData } =
    useContext(AuthContext);
  // "What's new" sidebar: opens by itself on the home screen when there is an unread update.
  const whatsNew = useWhatsNew(DivName === "Dashboard");

  const [isTourOpen, setIsTourOpen] = useState(false);

  const [Currentchoose, setCurrentchoose] = useState([]);

  // const [CharPopup, setCharPopup] = useState(false);

  const [Gender, setGender] = useState("Empty");

  const [popOptions, setpopOptions] = useState({
    char: true,
    face: false,
    clothes: false,
  });

  const [charActive, setcharActive] = useState("Gender");

  const [TopActive, setTopActive] = useState("Gender");

  const [colorChange, setcolorChange] = useState(false);

  const [CharacterName, setCharacterName] = useState("Default");

  const history = useHistory();

  const steps = [
    {
      selector: ".first-element",
      content: () => (
        <span>
          <h1 style={{ color: "#286aff" }}>Record</h1> your{" "}
          <strong> screen and camera</strong> Why waste time in meetings when
          you can get your message across quickly and easily?{" "}
          <strong>Record it, send it, done.</strong>
        </span>
      ),
    },
    {
      selector: ".Second-element",
      content: () => (
        <span>
          <h1 style={{ color: "#286aff" }}>Get inspired</h1> start creating
          quickly <strong>Curated templates</strong> to help you start creating
          based on your personal preferences.
        </span>
      ),
    },
    {
      selector: ".third-element",
      content: () => (
        <span>
          <h3 style={{ color: "#286aff" }}>Bring your brand</h3> to life{" "}
          <strong>Build</strong> animated characters that fit your brand. Choose
          their <strong>clothes, face, hair</strong>, add your{" "}
          <strong>logo, and more!</strong>
        </span>
      ),
    },
    {
      selector: ".leftbarWrapper",
      content: () => (
        <span>
          <h3 style={{ color: "#286aff" }}>Countless ways to create</h3>
          <li>Find all of our templates right here.</li>
          <li>Convert PPTX presentations to videos. Import and get started.</li>
          <li>Or simply create a Video from scratch.</li>
        </span>
      ),
    },
  ];

  const [UploadData, setUploadData] = useState(null);

  const uploadCharacterData = async (e) => {
    Swal({
      title: "Confirm to proceed.",
      text: "This character will be saved in your list of characters to be used in your videos.",
      icon: "info",
      buttons: [true, "Save Character"],
      cancelButtonColor: "#d33",
    }).then((result) => {
      if (result) {
        if (UploadData == null) {
          setUploadData(true);
        }
        if (UploadData) {
          setUploadData(false);
        }
        if (!UploadData) {
          setUploadData(true);
        }
      }
    });
  };

  const [canvZoom, setcanvZoom] = useState({ width: "", height: "" });

  const [readjson, setreadjson] = useState(false);

  const PopOptions = (params) => {
    if (Gender != "Empty") {
      if (params === "char") {
        setpopOptions({ char: true, face: false, clothes: false });
        setTopActive(charActive);
        let canvas = document.getElementsByClassName("ChrClass")[0];
        const ctx = document
          .getElementsByClassName("ChrClass")[0]
          .getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        setcanvZoom({ width: "540", height: "770" });
      }

      if (params === "face") {
        if (CharacterName === "Default") {
          setreadjson(true);
        }
        setpopOptions({ char: false, face: true, clothes: false });
        setTopActive("Head");
        setcanvZoom({ width: "1000", height: "1262" });
      }
      if (params === "clothes") {
        if (CharacterName === "Default") {
          setreadjson(true);
        }
        setpopOptions({ char: false, face: false, clothes: true });
        setTopActive("Shirts");
        let canvas = document.getElementsByClassName("ChrClass")[0];
        const ctx = document
          .getElementsByClassName("ChrClass")[0]
          .getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        setcanvZoom({ width: "540", height: "770" });
      }
    }
  };

  const CharacterPopup = () => {
    setCharPopup(true);
    setpopOptions({ char: true, face: false, clothes: false });
  };

  const getUserTemplate = () => {
    Swal({
      title: "Do you want to proceed?",
      text: "This will redirect you to the editor and load this template.",
      icon: "info",
      buttons: [true, "Proceed"],
    }).then((result) => {
      if (result) {
        localStorage.removeItem("CurrentChooseProject");
        sessionStorage.removeItem("CurrentChooseProjectId");
        sessionStorage.setItem("CurrentChooseProjectId", Currentchoose.id);
        history.push("/editor");
      } else {
        setpopupload(false);
      }
    });
  };

  const LoaderData = {
    loop: true,
    autoplay: true,
    animationData: load,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid meet",
      viewBoxOnly: true,
      progressiveLoad: true,
    },
  };

  const ForChooseTemplate = {
    loop: true,
    autoplay: true,
    animationData: ForTemp,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid meet",
      viewBoxOnly: true,
      progressiveLoad: true,
    },
  };

  const ForRecord = {
    loop: true,
    autoplay: true,
    animationData: ForRec,
  };

  const ForEditor = {
    loop: true,
    autoplay: true,
    animationData: ForEdit,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid meet",
      viewBoxOnly: true,
      progressiveLoad: true,
    },
  };

  //just trying
  const CreatedCharacter = {
    loop: true,
    autoplay: true,
    animationData: createdCharacterPath,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid meet",
      viewBoxOnly: true,
      progressiveLoad: true,
    },
  };

  const [ShowTemp, setShowTemp] = useState({
    Recent: true,
    AllRecent: false,
    Popular: true,
    AllPopular: false,
  });
  const [dialogOpen, setdialogOpen] = useState(false);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [oldPasswordError, setOldPasswordError] = useState('');
  const [newPasswordError, setNewPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const handleClickOpen = () => {
    setdialogOpen(true);
  };

  const handleDialogClose = () => {
    setdialogOpen(false);
  };

  const handleSubmit = () => {
    // Handle form submission here
 
    if (!newPassword || newPassword.length < 8) {
      setNewPasswordError('Password must be at least 8 characters');
      return;
    }
    if (!confirmPassword || confirmPassword.length < 8) {
      setConfirmPasswordError('Password must be at least 8 characters');
      return;
    }
    if (newPassword !== confirmPassword) {
      setConfirmPasswordError('Passwords do not match');
      return;
    }
    let formdata = new FormData();
    formdata.append("email", UserData.email);
    formdata.append("oldPassword", oldPassword);
    formdata.append("newPassword", newPassword);
    formdata.append("confirmPassword", confirmPassword);
    axios
      .post(
        authenticationData.ApiBaseURL + "/api/Account/ChangePassword",
        formdata,
        {
          headers: {
            "Content-Type": `multipart/form-data`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        setdialogOpen(false);
        setOldPassword('')
        setNewPassword('')
        setConfirmPassword('')
        if(res.data.status ==  true){
          swal({
            title: "Success!",
            text: res.data.result,
            icon: "success",
            button: "Ok",
          }).then(()=>{
            localStorage.clear();
            window.location.reload(false);
          });
        } 
        else{
          swal({
            title: "Error!",
            text: res.data.result,
            icon: "error",
            button: "Ok",
          });
          
        }
       
      });
  };

  useEffect(() => {
    if (popupload) {
      getUserTemplate();
    }
  }, [popupload]);

  const [pageLoaded, setPageLoaded] = useState(false);
  useEffect(() => {
    if (DivName === "Dashboard") {
      //this was supposed to show loader while we load character builder in dashboard
      //but this was causing issue from coming back from editor to templates directly.
      // props.setDeafultLoader({played:true,stat:true});
      setPageLoaded(false);
      const onPageLoad = () => {
        setTimeout(() => {
          setPageLoaded(true);
          props.setDeafultLoader({ played: false, stat: false });
        }, 500);
      };
      if (document.readyState === "complete") {
        onPageLoad();
      } else {
        window.addEventListener("load", onPageLoad);
        // Remove the event listener when component unmounts
        return () => window.removeEventListener("load", onPageLoad);
      }
    }
  }, [DivName]);

  const windowScrollBinding = () => {
    window.onscroll = function (e) {
      // if (isTourOpen) {
      //   setIsTourOpen(false)
      // }
      //alert('scroll hit')
    };
  };

  const getPreviousGesture = async () => {
    var resp = null;
    var arr = JSON.parse(JSON.stringify(arrayPreviewGestures));
    for (var i = 0; i < arrayPreviewGestures.length; i++) {
      if (arrayPreviewGestures[i].isActive === "true") {
        //Checking if its 0 index
        if (i == 0) {
          resp = await fetch(
            createdCharacterURL + arrayPreviewGestures[4].gesture + ".json"
          );
          //Updating Active value of 4th Index
          const result = arr.map((o) => ({
            ...o,
            gesture: o.gesture,
            isActive: "false",
          }));

          result[4] = {
            gesture: arrayPreviewGestures[4].gesture,
            isActive: "true",
          };

          setarrayPreviewGestures(result);
          setactivePreviewGesture(result[4].isActive);
          break;
        } else {
          resp = await fetch(
            createdCharacterURL + arrayPreviewGestures[i - 1].gesture + ".json"
          );
          //Updating Active value of Previous Index
          const result = arr.map((o) => ({
            ...o,
            gesture: o.gesture,
            isActive: "false",
          }));

          result[i - 1] = {
            gesture: arrayPreviewGestures[i - 1].gesture,
            isActive: "true",
          };
          setarrayPreviewGestures(result);
          setactivePreviewGesture(result[i - 1].isActive);
          break;
        }
      }
    }
    //const resp = await fetch(createdCharacterURL +  + ".json");
    const jsonData = await resp.json();
    setcreatedCharacterPath(jsonData);
  };

  const getNextGesture = async () => {
    var resp = null;
    var arr = JSON.parse(JSON.stringify(arrayPreviewGestures));
    for (var i = 0; i < arrayPreviewGestures.length; i++) {
      if (arrayPreviewGestures[i].isActive === "true") {
        //Checking if its 0 index
        if (i == 4) {
          resp = await fetch(
            createdCharacterURL + arrayPreviewGestures[0].gesture + ".json"
          );
          //Updating Active value of 4th Index
          const result = arr.map((o) => ({
            ...o,
            gesture: o.gesture,
            isActive: "false",
          }));

          result[0] = {
            gesture: arrayPreviewGestures[0].gesture,
            isActive: "true",
          };
          setarrayPreviewGestures(result);
          break;
        } else {
          resp = await fetch(
            createdCharacterURL + arrayPreviewGestures[i + 1].gesture + ".json"
          );
          //Updating Active value of Previous Index
          const result = arr.map((o) => ({
            ...o,
            gesture: o.gesture,
            isActive: "false",
          }));

          result[i + 1] = {
            gesture: arrayPreviewGestures[i + 1].gesture,
            isActive: "true",
          };
          setarrayPreviewGestures(result);
          break;
        }
      }
    }
    //const resp = await fetch(createdCharacterURL +  + ".json");
    const jsonData = await resp.json();
    setcreatedCharacterPath(jsonData);
  };
  // <div onLoad={windowScrollBinding} className="mainDashboard">

  const UseInEdtior = (params) => {
    sessionStorage.removeItem("createNewProject");
    sessionStorage.removeItem("myProjectData");
    sessionStorage.removeItem("CurrentChooseProjectId");
    sessionStorage.setItem("createNewProject", "newProject");
    if (Role == "admin") {
      let str;
      if (params === "Horizontal") {
        str = "16:9";
      } else if (params === "Square") {
        str = "1:1";
      } else if (params === "Vertical") {
        str = "9:16";
      }
      sessionStorage.setItem("ProjectAspectRatio", str);
      history.push("./editor");
    } else {
      let str;
      if (params === "Horizontal") {
        str = "16:9";
      } else if (params === "Square") {
        str = "1:1";
      } else if (params === "Vertical") {
        str = "9:16";
      }
      sessionStorage.setItem("ProjectAspectRatio", str);
      history.push("./editor");
    }
  };

  return (
    <div className="mainDashboard">
      <WhatsNew {...whatsNew.panel} />
      {whatsNew.admin}
      <Tour
        steps={steps}
        isOpen={isTourOpen}
        onRequestClose={() => setIsTourOpen(false)}
        disableInteraction={true}
        lastStepNextButton={
          <span style={{ fontSize: "14px" }}>Done! Let's start Building</span>
        }
        startAt={0}
      />

      <div className="contentDashboard">
        <div className="contentArea">
          <div className="flexRow mb-3 justify-spaced">
            <div>
              <h1 className="DashbordHeadings">
                {DivName === "Dashboard" && (
                  <span>Hi {UserData.userName}!</span>
                )}
                {DivName === "Templates" && <span>Templates</span>}
                {DivName === "My Projects" && <span>My Projects</span>}
                {DivName === "Create" && <span>Create a new video</span>}
                {DivName === "AI Studio" && <span>AI Studio</span>}
                {DivName === "Agency" && <span>Agency Template ShowCase</span>}
                {DivName === "Import" && <span>Import</span>}
                {DivName === "Notifications" && <span>Notifications</span>}
                {DivName === "My Videos" && <span>My Videos</span>}
                {DivName === "My Purchases" && <span>My Purchases</span>}
              </h1>
            </div>

            <div>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <WhatsNewButton onClick={whatsNew.show} unread={whatsNew.unread} />
                <Tooltip title="Account settings">
                  <IconButton
                    onClick={handleClick}
                    size="small"
                    sx={{ ml: 2 }}
                    aria-controls={open ? "account-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                  >
                    <Avatar sx={{ width: 32, height: 32, bgcolor: "#333333" }}>
                      <PersonIcon />
                    </Avatar>
                  </IconButton>
                </Tooltip>
              </Box>
              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                //onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <Typography sx={{ p: 2 }}>{UserData.email}</Typography>
                <Divider></Divider>
                <MenuItem
                  sx={{ p: 2 }}
                  onClick={handleClickOpen}
                >
                  <ListItemIcon>
                    <PasswordIcon fontSize="small" />
                  </ListItemIcon>
                  Change Password
                </MenuItem>
                <MenuItem
                  sx={{ p: 2 }}
                  onClick={() => {
                    localStorage.clear();
                    window.location.reload(false);
                  }}
                >
                  <ListItemIcon>
                    <Logout fontSize="small" />
                  </ListItemIcon>
                  Logout
                </MenuItem>
              </Menu>
            </div>
            <Dialog open={dialogOpen} onClose={handleDialogClose} fullWidth maxWidth="xs" PaperProps={{ style: { borderRadius: '30px' } }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop:'40px' }}>
              <img style={{height:"45px", marginBottom:'10px'}} src="images/pas.png" alt="" />
                 <Typography variant="h5" style={{ fontWeight: 'bold' }}>Set a new password</Typography> <Typography style={{ fontWeight: 'bold', color: '#808080'   }}>Must be atleast 8 characters</Typography> </div>
              <DialogContent>
              <Typography style={{ fontWeight: 'bold' }}>Enter your old password</Typography>
                <TextField
                  autoFocus
                  margin="dense"
                  id="old-password"
                  type={showOldPassword ? "text" : "password"}
                  size="small"
                  variant="filled"
                  placeholder="Enter password"
                  fullWidth
                  value={oldPassword}
                  onChange={(e) => {
                    setOldPassword(e.target.value);
                    setOldPasswordError(''); // Clear old password error when user types
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowOldPassword(!showOldPassword)}
                          onMouseDown={(e) => e.preventDefault()}
                        >
                          {showOldPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  style={{ borderRadius: '50%' }}
                />
                  {oldPasswordError && <Typography style={{ color: 'red' }}>{oldPasswordError}</Typography>}
    
              <Typography style={{ fontWeight: 'bold' , marginTop:'20px' }}>Enter your new password</Typography>

                <TextField
                  margin="dense"
                  id="new-password"
                  type={showNewPassword ? "text" : "password"}
                  variant="filled"
                  fullWidth
                  size="small"
                  placeholder="Enter password"

                  value={newPassword}
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                    setNewPasswordError(''); // Clear new password error when user types
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowNewPassword(!showNewPassword)}
                          onMouseDown={(e) => e.preventDefault()}
                        >
                          {showNewPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  style={{ borderRadius: '50%' }}
                />
                 {newPasswordError && <Typography style={{ color: 'red' }}>{newPasswordError}</Typography>}
    
              <Typography style={{ fontWeight: 'bold', marginTop:'20px'  }}>Confirm password</Typography>

                <TextField
                  margin="dense"
                  id="confirm-password"
                  type={showConfirmPassword ? "text" : "password"}
                  size="small"
                  variant="filled"
                  placeholder="Enter password"

                  fullWidth
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                    setConfirmPasswordError(''); // Clear confirm password error when user types
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          onMouseDown={(e) => e.preventDefault()}
                        >
                          {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  style={{ borderRadius: '50%'}}
                />
                 {confirmPasswordError && <Typography style={{ color: 'red' }}>{confirmPasswordError}</Typography>}
    
                <Button style={{marginTop:'20px' }} fullWidth onClick={handleSubmit} variant="contained" >
                  Reset Password
                </Button>
                <Button fullWidth onClick={handleDialogClose} style={{ color: 'black' }} >Cancel</Button>

              </DialogContent>

            </Dialog>
            {/* <button
                onClick={() => {
                  setDivName("Dashboard");
                  setIsTourOpen(true);
                }}
                className="TourButton"
              >
                <Tooltip title="Tour" position="bottom" trigger="mouseenter">
                  <span className="material-icons material-icons-outlined">
                    tour
                  </span>
                </Tooltip>
              </button> */}

            {/* <button
                style={{ marginRight: "10px" }}
                className="TourButton"
                onClick={() => {
                  setDivName("Notifications");
                }}
              >
                <Tooltip
                  title="Notification"
                  position="bottom"
                  trigger="mouseenter"
                  arrowSize="regular"
                >
                  <span className="material-icons material-icons-outlined">
                    notifications_active
                  </span>
                </Tooltip>
              </button> */}
          </div>

          {DivName === "Dashboard" && (
            <>
              <AIStudioBanner />
              <div className="row mb-5">
                <div className="col-12">
                  <h5>What would you like to do today?</h5>
                </div>
                <div className="gridView mt-2">
                  <div className="third-element" onClick={CharacterPopup}>
                    <div className="griditem">
                      <div className="card" style={{ background: "#00c0d4" }}>
                        <div className="image" style={{ bottom: "0px" }}>
                          <Lottie
                            options={ForEditor}
                            height={200}
                            width={370}
                            isStopped={false}
                            isPaused={false}
                          />
                        </div>
                        <div className="cardDetailsWrapper">
                          <div className="cardDetails">
                            <div className="cardinsider2">
                              <div className="cardtitle">Character Builder</div>
                            </div>
                            <div className="cardShadow">
                              <p className="cardSubDetails">
                                Made Your Own Character
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="Second-element"
                    onClick={() => {
                      setDivName("Templates");
                    }}
                  >
                    <div className="griditem">
                      <div className="card" style={{ background: "#f4a523" }}>
                        <div className="image" style={{ bottom: "6px" }}>
                          <div>
                            <Lottie
                              options={ForChooseTemplate}
                              height={220}
                              width={355}
                              isStopped={false}
                              isPaused={false}
                            />
                          </div>
                        </div>
                        <div className="cardDetailsWrapper">
                          <div className="cardDetails">
                            <div className="cardinsider2">
                              <div className="cardtitle">Templates</div>
                            </div>
                            <div className="cardShadow">
                              <p className="cardSubDetails">Choose Templates</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="first-element"
                    onClick={() => {
                      setDivName("Create");
                    }}
                  >
                    <div className="griditem">
                      <div className="card" style={{ background: "#cee1fe" }}>
                        <div className="image">
                          <div>
                            <Lottie
                              options={ForRecord}
                              height={380}
                              width={380}
                              isStopped={false}
                              isPaused={false}
                            />
                          </div>
                        </div>
                        <div className="cardDetailsWrapper">
                          <div className="cardDetails">
                            <div className="cardinsider2">
                              <div className="cardtitle">Create Canvas</div>
                            </div>
                            <div className="cardShadow">
                              <p className="cardSubDetails">
                                Create New Project
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* <div style={{
                      position: 'absolute',
                      width: '100%',
                      top: '0px',
                      left: '0px',
                      height: '100%',
                      background: '#7c7979',
                      opacity: '0.6',
                      borderRadius: '15px'
                    }}
                    >
                      <span className="material-icons" style={{
                        fontSize: '30px',
                        position: 'absolute',
                        right: '13px',
                        top: '10px'
                      }}>
                        lock
                      </span>
                    </div> */}
                    </div>
                  </div>
                </div>
              </div>

              <div id="popup-root"></div>

              {pageLoaded && (
                <>
                  <Popup
                    className="anyone"
                    open={CharPopup}
                    closeOnDocumentClick={false}
                  >
                    <div className="ChrPop">
                      <div
                        className="chrpopX1"
                        id="chrpopX1"
                        onClick={() => {
                          setCharPopup(false);
                          setGender("Empty");
                          setTopActive("Gender");
                          setreadjson(false);
                          setcanvZoom({ width: "", height: "" });
                          setUploadData(null);
                          if (redirect.status) {
                            setDivName(redirect.path);
                            setredirect({ path: null, status: false });
                          }
                        }}
                      >
                        <span
                          style={{
                            fontSize: "30px",
                          }}
                          className="material-icons ChrPopCross"
                        >
                          close
                        </span>
                      </div>

                      <div className="chrpopInner">
                        <div className="ChrPopMidContainer">
                          <div className="chrpopLeftPanel">
                            <div className="chrpopLeftPanelStart">
                              <div
                                style={{
                                  position: "absolute",
                                  top: "110px",
                                  width: "100%",
                                }}
                              >
                                {popOptions.char && (
                                  <div>
                                    {/* <img className='chrImgbefore' src="images/before.svg" alt="" /> */}
                                    <div className="leftAreaInnerParentActive">
                                      <div className="LeftAreaInner">
                                        <span className="material-icons customLeftIconActive">
                                          accessibility
                                        </span>
                                      </div>
                                      <div className="activefontparent">
                                        <span className="leftPanelFontActive">
                                          Character
                                        </span>
                                      </div>
                                    </div>
                                    {/* <img className='chrImgafter' src="images/before.svg" alt="" /> */}
                                  </div>
                                )}

                                {!popOptions.char && (
                                  <div>
                                    <div
                                      className="leftAreaInnerParent"
                                      onClick={() => PopOptions("char")}
                                    >
                                      <div className="LeftAreaInner">
                                        <span className="material-icons customLeftIcon">
                                          accessibility
                                        </span>
                                      </div>
                                      <div className="activefontparent">
                                        <span className="leftPanelFont">
                                          Character
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {popOptions.face && (
                                  <div>
                                    {/* <img style={{ top: '40px' }} className='chrImgbefore' src="images/before.svg" alt="" /> */}
                                    <div className="leftAreaInnerParentActive">
                                      <div className="LeftAreaInner">
                                        <span className="material-icons customLeftIconActive">
                                          face
                                        </span>
                                      </div>
                                      <div className="activefontparent">
                                        <span className="leftPanelFontActive">
                                          face
                                        </span>
                                      </div>
                                    </div>
                                    {/* <img style={{ top: '110px' }} className='chrImgafter' src="images/before.svg" alt="" /> */}
                                  </div>
                                )}

                                {!popOptions.face && (
                                  <div
                                    className={
                                      "leftAreaInnerParent" +
                                      (Gender === "Empty" ? " subIconDim" : "")
                                    }
                                    onClick={() => PopOptions("face")}
                                  >
                                    <div className="LeftAreaInner">
                                      <span className="material-icons customLeftIcon">
                                        face
                                      </span>
                                    </div>
                                    <div className="activefontparent">
                                      <span className="leftPanelFont">
                                        face
                                      </span>
                                    </div>
                                  </div>
                                )}

                                {popOptions.clothes && (
                                  <div>
                                    {/* <img style={{ top: '102px' }} className='chrImgbefore' src="images/before.svg" alt="" /> */}
                                    <div className="leftAreaInnerParentActive">
                                      <div className="LeftAreaInner">
                                        <span className="material-icons customLeftIconActive">
                                          checkroom
                                        </span>
                                      </div>
                                      <div className="activefontparent">
                                        <span className="leftPanelFontActive">
                                          Get Up
                                        </span>
                                      </div>
                                    </div>
                                    {/* <img style={{ top: '173px' }} className='chrImgafter' src="images/before.svg" alt="" /> */}
                                  </div>
                                )}

                                {!popOptions.clothes && (
                                  <div
                                    className={
                                      "leftAreaInnerParent" +
                                      (Gender === "Empty" ? " subIconDim" : "")
                                    }
                                    onClick={() => PopOptions("clothes")}
                                  >
                                    <div className="LeftAreaInner">
                                      <span className="material-icons customLeftIcon">
                                        checkroom
                                      </span>
                                    </div>
                                    <div className="activefontparent">
                                      <span className="leftPanelFont">
                                        Get Up
                                      </span>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>

                            <PopL_AreaR_Side
                              setTopActive={setTopActive}
                              actives={popOptions}
                              Gender={Gender}
                              PopOptionsfun={PopOptions}
                              CharacterName={CharacterName}
                              charActive={charActive}
                              setcharActive={setcharActive}
                              key={"1"}
                              TopActive={TopActive}
                            />
                          </div>

                          <PopRightArea
                            key={"Pra1"}
                            arrayPreviewGestures={arrayPreviewGestures}
                            setCharPopup={setCharPopup}
                            setcreatedCharacterPath={setcreatedCharacterPath}
                            setcreatedCharacterURL={setcreatedCharacterURL}
                            createdCharacterURL={createdCharacterURL}
                            setshowCreationPopup={setshowCreationPopup}
                            setDeafultLoader={props.setDeafultLoader}
                            UploadData={UploadData}
                            setUploadData={setUploadData}
                            get={get}
                            keys={2}
                            CharacterName={CharacterName}
                            canvZoom={canvZoom}
                            setCharacterName={setCharacterName}
                            colorChange={colorChange}
                            setreadjson={setreadjson}
                            PopOptionsfun={PopOptions}
                            setcanvZoom={setcanvZoom}
                            rjson={readjson}
                            setActiveLeftBar={setpopOptions}
                            Gender={Gender}
                            setcolorChange={setcolorChange}
                            ActiveLeftBar={popOptions}
                            setGender={setGender}
                            setTopActive={setTopActive}
                            setcharActive={setcharActive}
                            charActive={charActive}
                            TopActive={TopActive}
                          />

                          {/* {popOptions.char != true && (
                      <div className="uploadChar">
                        <button className="UploadBtn" onClick={uploadCharacterData}>
                          <span className="material-icons-outlined" style={{ fontSize: '16px' }}>
                            file_upload
                          </span>
                          <span style={{ padding: '7px' }}>
                            Upload
                          </span>
                        </button>
                      </div>
                    )} */}

                          {popOptions.char != true && (
                            <div className="uploadChar">
                              <button
                                className="UploadBtnGreen"
                                onClick={uploadCharacterData}
                              >
                                <span style={{ padding: "7px" }}>
                                  Save Character
                                </span>
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </Popup>

                  <Popup
                    className="anyone"
                    open={showCreationPopup}
                    closeOnDocumentClick={false}
                  >
                    <div className="ChrPop">
                      <div
                        className="chrpopX1"
                        id="chrpopX2"
                        onClick={() => {
                          setshowCreationPopup(false);
                        }}
                      >
                        <span
                          style={{
                            fontSize: "30px",
                          }}
                          className="material-icons ChrPopCross"
                        >
                          close
                        </span>
                      </div>

                      <div className="chrpopInner">
                        <div className="ChrPopMidContainer">
                          <div className="previewCharacterBuild">
                            <div className="leftSide">
                              <div className="backSlider">
                                <div
                                  className="sliderLeft"
                                  onClick={() => getPreviousGesture()}
                                >
                                  <span
                                    style={{
                                      fontSize: "60px",
                                      color: "#a2bad9",
                                    }}
                                    className="material-icons material-icons-outlined"
                                  >
                                    navigate_before
                                  </span>
                                </div>
                                {/* <div className="gesture-name">DANCE</div> */}
                                <div className="sliderRight">
                                  <span
                                    style={{
                                      fontSize: "60px",
                                      color: "#a2bad9",
                                    }}
                                    onClick={() => getNextGesture()}
                                    className="material-icons material-icons-outlined"
                                  >
                                    navigate_next
                                  </span>
                                </div>
                              </div>
                              {/* <div className="GestureNamePreview">{activePreviewGesture}</div> */}
                              <div className="character-animate">
                                <Lottie
                                  options={CreatedCharacter}
                                  className="createdChar-size"
                                  height="auto"
                                  width="55%"
                                  isStopped={false}
                                  isPaused={false}
                                />
                              </div>
                            </div>
                            <div className="rightSide">
                              <div>Congratulations! 🎉</div>
                              <div>
                                Your character is ready with 100 Gestures.
                              </div>
                              <div
                                className="created-character-btn mt-5"
                                onClick={() => {
                                  UseInEdtior("Horizontal");
                                }}
                              >
                                Use in Editor
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Popup>
                </>
              )}
              {/* {ShowTemp.Recent && (
              <RecentUseTemplates ShowTemp={ShowTemp} setShowTemp={setShowTemp} Currentchoose={Currentchoose} setCurrentchoose={setCurrentchoose} popupload={popupload}
                setpopupload={setpopupload} />
            )}

            {ShowTemp.AllRecent && (
              <AllRecentTemplates ShowTemp={ShowTemp} setShowTemp={setShowTemp} Currentchoose={Currentchoose} setCurrentchoose={setCurrentchoose} popupload={popupload}
                setpopupload={setpopupload} />
            )} */}

              {ShowTemp.Popular && (
                <PopularTemplates
                  ShowTemp={ShowTemp}
                  setShowTemp={setShowTemp}
                  Currentchoose={Currentchoose}
                  setCurrentchoose={setCurrentchoose}
                  popupload={popupload}
                  setpopupload={setpopupload}
                />
              )}

              {ShowTemp.AllPopular && (
                <AllPopularTemplates
                  ShowTemp={ShowTemp}
                  setShowTemp={setShowTemp}
                  Currentchoose={Currentchoose}
                  setCurrentchoose={setCurrentchoose}
                  popupload={popupload}
                  setpopupload={setpopupload}
                />
              )}
            </>
          )}

          {DivName === "Templates" && <Templates />}

          {DivName === "My Projects" && <SaveProject />}

          {DivName === "Create" && <Create />}

          {DivName === "AI Studio" && (
            <AIStudioGate>
              <AIStudio />
            </AIStudioGate>
          )}

          {DivName === "Agency" && <AgencyPanel />}

          {DivName === "My Purchases" && <MyPurchases />}

          {/* {DivName === "Import" && (<TempImport />)} */}

          {DivName === "Notifications" && <Notification />}

          {DivName === "My Videos" && (
            <MyVideos setDeafultLoader={props.setDeafultLoader} />
          )}
        </div>
      </div>
    </div>
  );
};

export default RightArea;
